module.exports = __webpack_public_path__ + "img/rappi.0512c59b.svg";